import React from "react";
import { X } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";

/**
 * Right-side drawer matching Contacts “New contact” (overlay + neo-drawer panel).
 */
export default function AdminSideDrawer({
  open = true,
  onClose,
  eyebrow,
  title,
  children,
  footer,
  testId,
  wide = false,
}) {
  const reduce = useReducedMotion();
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-stretch justify-end bg-black/25 p-0 sm:p-4"
      onClick={onClose}
      data-testid={testId}
    >
      <motion.aside
        initial={reduce ? false : { x: 28, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.25 }}
        className={`neo-panel neo-drawer flex h-full w-full flex-col overflow-hidden rounded-none sm:rounded-2xl ${
          wide ? "max-w-lg" : "max-w-md"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3 border-b border-[var(--t-border)] px-6 py-5">
          <div className="min-w-0">
            {eyebrow ? <div className="label-eyebrow mb-2">{eyebrow}</div> : null}
            <div className="font-heading truncate text-2xl tracking-tight !font-extralight">
              {title}
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl p-2 text-[var(--t-meta)] hover:bg-black/[0.04] hover:text-[var(--t-text)]"
            aria-label="Close"
          >
            <X size={18} strokeWidth={1.5} />
          </button>
        </div>
        <div className="flex min-h-0 flex-1 flex-col">{children}</div>
        {footer ? (
          <div className="flex items-center justify-end gap-3 border-t border-[var(--t-border)] px-6 py-4">
            {footer}
          </div>
        ) : null}
      </motion.aside>
    </div>
  );
}

export function DrawerFormBody({ children }) {
  return (
    <div className="t-scroll-soft flex-1 space-y-4 overflow-y-auto px-6 py-5">{children}</div>
  );
}
